import { Typing } from "@blockwell/eth-types";
export function isLiteralSource(source) {
    return source?.type === "literal";
}
export function getLiteralSourceParameters(arg) {
    if (arg?.value?.type === "literal") {
        return arg.value.parameters;
    }
    return null;
}
export function isCallSource(source) {
    return source?.type === "call";
}
export function getCallSourceParameters(arg) {
    if (arg?.value?.type === "call") {
        return arg.value.parameters;
    }
    return null;
}
export function isDynamicSource(source) {
    return source?.type === "dynamic";
}
export function getDynamicSourceParameters(arg) {
    if (arg?.value?.type === "dynamic") {
        return arg.value.parameters;
    }
    return null;
}
export function isFeeSource(source) {
    return source?.type === "fee";
}
export function getFeeSourceParameters(arg) {
    if (arg?.value?.type === "fee") {
        return arg.value.parameters;
    }
    return null;
}
export function isJsonSource(source) {
    return source?.type === "json";
}
export function getJsonSourceParameters(arg) {
    if (arg?.value?.type === "json") {
        return arg.value.parameters;
    }
    return null;
}
export function isOtherSource(source) {
    return source?.type === "other";
}
export function getOtherSourceParameters(arg) {
    if (arg?.value?.type === "other") {
        return arg.value.parameters;
    }
    return null;
}
export function isStepsSource(source) {
    return source?.type === "steps";
}
export function getStepsSourceParameters(arg) {
    if (arg?.value?.type === "steps") {
        return arg.value.parameters;
    }
    return null;
}
export function isUniswapSource(source) {
    return source?.type === "uniswap";
}
export function getUniswapSourceParameters(arg) {
    if (arg?.value?.type === "uniswap") {
        return arg.value.parameters;
    }
    return null;
}
function createSource(type, parameters) {
    return {
        type,
        parameters: parameters,
    };
}
export function createLiteralSource(value) {
    return createSource("literal", { value });
}
export function createDynamicSource(name) {
    return createSource("dynamic", { name });
}
export function createCallSource(abi, address, args) {
    return createSource("call", {
        abi,
        address,
        arguments: args
    });
}
export function createFeeSource(base, multiplier, ignoreDecimals) {
    let params = {
        base, multiplier
    };
    if (ignoreDecimals) {
        params.ignoreDecimals = true;
    }
    return createSource("fee", params);
}
export function createJsonSource(json, mergeWith) {
    return createSource("json", {
        json, mergeWith
    });
}
export function createSenderSource() {
    return createSource("other", {
        name: "sender"
    });
}
/**
 * @param step Step number, starting with 1.
 * @param name Name of the property from the step.
 */
export function createStepsSource(step, name) {
    return createSource("steps", {
        step, name
    });
}
export const EthValueArgument = {
    type: "uint",
    typing: Typing.uint,
    decimals: createLiteralSource(18),
};
export const EthAddressArgument = {
    type: "address",
    typing: Typing.address
};
export const EthStringArgument = {
    type: "string",
    typing: Typing.string
};
